import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';


document.addEventListener('alpine:init', () => {
    Alpine.data('initHeroHomeSlider', () => ({
        open: false,
        swiper: {},
        init() {
            new Swiper(this.$refs.swiperContainer, {
                modules: [Navigation, Pagination, EffectFade, Autoplay],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 5000,
                },
                fadeEffect: {
                    crossFade: true
                },

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            })
        }
    }))
})